var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiscellaneousTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "test",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.935,
    height: 17.272,
    viewBox: "0 0 16.935 17.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34761",
    "data-name": "Group 34761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34760",
    "data-name": "Group 34760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M16.606,0H5.26a.282.282,0,0,0-.277.288v16.7a.282.282,0,0,0,.277.288H16.606a.282.282,0,0,0,.277-.288V.288A.282.282,0,0,0,16.606,0Zm-.277,16.7H5.536V.576H16.329Z",
    transform: "translate(-4.983)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34763",
    "data-name": "Group 34763",
    transform: "translate(2.545 10.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34762",
    "data-name": "Group 34762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M76.113,332.8H73.568a.318.318,0,0,0-.318.318v2.545a.318.318,0,0,0,.318.318h2.545a.318.318,0,0,0,.318-.318v-2.545A.318.318,0,0,0,76.113,332.8Zm-.318,2.545H73.886v-1.909h1.909Z",
    transform: "translate(-73.25 -332.8)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34765",
    "data-name": "Group 34765",
    transform: "translate(2.656 3.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34764",
    "data-name": "Group 34764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M79.418,104.448l-2.02,1.731-.748-.641-.413.483.954.818a.317.317,0,0,0,.414,0l2.227-1.909Z",
    transform: "translate(-76.237 -104.448)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34767",
    "data-name": "Group 34767",
    transform: "translate(2.638 7.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34766",
    "data-name": "Group 34766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M78.744,216.284l-.45-.45-1.047,1.047L76.2,215.834l-.45.45,1.047,1.047-1.047,1.047.45.45,1.047-1.047,1.047,1.047.45-.45L77.7,217.331Z",
    transform: "translate(-75.75 -215.834)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34769",
    "data-name": "Group 34769",
    transform: "translate(6.443 4.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34768",
    "data-name": "Group 34768"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3783",
    "data-name": "Rectangle 3783",
    width: 3.817,
    height: 0.636
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34771",
    "data-name": "Group 34771",
    transform: "translate(6.443 8.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34770",
    "data-name": "Group 34770"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3784",
    "data-name": "Rectangle 3784",
    width: 3.817,
    height: 0.636
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34773",
    "data-name": "Group 34773",
    transform: "translate(6.443 12.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34772",
    "data-name": "Group 34772"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3785",
    "data-name": "Rectangle 3785",
    width: 3.817,
    height: 0.636
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34775",
    "data-name": "Group 34775",
    transform: "translate(12.536 2.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34774",
    "data-name": "Group 34774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M392.8,98.542v-2.13a.318.318,0,0,0-.318-.318h-.954V94.821a.955.955,0,0,0-.954-.954h-.636a.955.955,0,0,0-.954.954v9.543a.318.318,0,0,0,.045.164l.954,1.59a.318.318,0,0,0,.545,0l.954-1.59a.317.317,0,0,0,.046-.164V96.73h.636v1.908a.32.32,0,0,0,.053.177l.636.954.529-.353Zm-2.545,6.794-.583-.972h1.167Zm.636-1.608h-1.272v-2.545h1.272Zm0-3.181h-1.272V96.73h1.272Zm0-4.453h-1.272V94.821a.318.318,0,0,1,.318-.318h.636a.318.318,0,0,1,.318.318Z",
    transform: "translate(-388.983 -93.867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneousTask);
export default __webpack_public_path__ + "static/media/miscellaneous-task.df51c6ce88d6eb7e2289bb4bf9ae18b7.svg";
export { ForwardRef as ReactComponent };